import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useModal } from '@composables/useModal.ts';

export const useSelectionArchiveStore = defineStore('selectionArchive', () => {
  const {
    isOpen: isArchiveModalOpen,
    openModal,
    closeModal: closeArchiveModal,
  } = useModal();

  const selectionItemIdToArchive = ref<number | null>(null);

  const openArchiveModal = (selectionItemId: number): void => {
    selectionItemIdToArchive.value = selectionItemId;
    openModal();
  };

  return {
    isArchiveModalOpen,
    openArchiveModal,
    closeArchiveModal,
    selectionItemIdToArchive,
  };
});
